var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.htmlTag,
    _vm._g(
      {
        tag: "component",
        class: _vm.buttonClass,
        attrs: { disabled: _vm.disabled, "aria-label": _vm.label }
      },
      _vm.$listeners
    ),
    [
      _vm._t("default", function() {
        return [_vm._v(_vm._s(_vm.label))]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }